import { HANDLING_CODES } from '@/errorManagement/utils';

export const types = {
  SET_ERROR: 'ERROR/SET_ERROR',
};
export const actions = {
  setError: (data) => ({
    type: types.SET_ERROR,
    payload: { data },
  }),
};
const initialState = {
  service: null,
  errorToPrint: null,
  handlingCode: 0,
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ERROR: {
      const { payload } = action;
      const { data } = { ...payload };
      const { service, errorToPrint, handlingCode, phone900, homeUrl } = { ...data };
      if (handlingCode !== HANDLING_CODES.NOTHING_TO_DO) {
        return {
          ...state,
          service,
          errorToPrint,
          handlingCode,
          phone900,
          homeUrl,
        };
      }
      return {
        ...state,
        service,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
export default reducer;
